import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { PureComponent, Fragment } from 'react';
import styled from 'styled-components';
import VizExIconButton from 'visitor-ui-component-library/button/VizExIconButton';
import { MessageEditorTooltip } from '../../message-editor/components/MessageEditorTooltip';
import VizExIcon from 'visitor-ui-component-library/icon/VizExIcon';
import SVGAttachment from 'visitor-ui-component-library-icons/icons/SVGAttachment';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HiddenInput = styled.input.withConfig({
  displayName: "AttachmentPickerButton__HiddenInput"
})(["display:none;"]);
class AttachmentPickerButton extends PureComponent {
  constructor(props) {
    super(props);
    this.inputRefCallback = ref => {
      this.inputRef = ref;
    };
    this.findInputNode = () => {
      if (!this.inputRef) {
        return null;
      }
      return this.inputRef;
    };
    this.clearInputNode = () => {
      const inputNode = this.findInputNode();
      if (inputNode) {
        inputNode.value = '';
      }
    };
    this.handlePickerClick = e => {
      const inputNode = this.findInputNode();
      if (inputNode) {
        inputNode.click();
      }
      this.props.onClick(e);
    };
    this.onInputChange = ({
      target: {
        files
      }
    }) => {
      this.props.onSelectFiles({
        files
      });
      this.clearInputNode();
    };
    this.renderTooltipContent = () => {
      if (this.props.mobile) {
        return undefined;
      }
      if (!this.props.hasConversationStarted) {
        return I18n.text('conversations-visitor-experience-components.attachmentDisabledTooltip');
      }
      if (this.props.disabled) {
        return undefined;
      }
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-visitor-ui.fileSizeLimit",
        options: {
          size: I18n.formatSize(this.props.maxAttachmentFileSize)
        }
      });
    };
    this.inputRef = null;
  }
  render() {
    const {
      disabled
    } = this.props;
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(MessageEditorTooltip, {
        content: this.renderTooltipContent(),
        placement: "top right",
        children: /*#__PURE__*/_jsx(VizExIconButton, {
          disabled: disabled,
          onClick: this.handlePickerClick,
          use: "default-on-background",
          "aria-label": I18n.text('conversations-visitor-ui.visitorExperienceAriaLabels.attachment'),
          shape: "circle",
          "data-test-id": "AttachmentPickerButton-VizExIconButton",
          children: /*#__PURE__*/_jsx(VizExIcon, {
            icon: /*#__PURE__*/_jsx(SVGAttachment, {}),
            size: "18px"
          })
        })
      }), /*#__PURE__*/_jsx(HiddenInput, {
        accept: this.props.accept.join(','),
        "data-selenium-test": "visitor-attachment-file-input",
        "data-test-id": "AttachmentPickerButton-input",
        disabled: this.props.disabled,
        ref: this.inputRefCallback,
        type: "file",
        multiple: this.props.allowMultiple,
        onChange: this.onInputChange
      })]
    });
  }
}
AttachmentPickerButton.displayName = 'AttachmentPickerButton';
AttachmentPickerButton.defaultProps = {
  accept: [],
  allowMultiple: false,
  onClick: () => {}
};
export default AttachmentPickerButton;